export default async function ({ store, redirect }) {
  if (!store.getters["user/IS_INF"]) return redirect("/")
  else {
    return redirect(`/influencer/profile/${store.state.user.influencer.slug}`)
  }
}
